module.exports = __webpack_public_path__ + "static/img/shape12.9289d1d7.png";